import { render, staticRenderFns } from "./TopBarComponent.vue?vue&type=template&id=358808f2&scoped=true"
import script from "./TopBarComponent.vue?vue&type=script&lang=js"
export * from "./TopBarComponent.vue?vue&type=script&lang=js"
import style0 from "./TopBarComponent.vue?vue&type=style&index=0&id=358808f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358808f2",
  null
  
)

export default component.exports